"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getMoneyFormat = function getMoneyFormat() {
  var _window, _window$theme;

  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$theme = _window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.moneyFormat) || '£{{amount}}';
};

var _default = getMoneyFormat;
exports["default"] = _default;